document.addEventListener("DOMContentLoaded", function () {
  // Handle team image switch on hover
  const buttons = document.querySelectorAll(".team-name");
  const images = document.querySelectorAll(".team-image");
  let activeIndex = 0;

  buttons.forEach((button) => {
    button.addEventListener("mouseover", function () {
      const teamIndex = parseInt(this.getAttribute("data-team"));
      if (teamIndex === activeIndex) return;

      // Update button active state
      buttons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      // Update images
      images[activeIndex].classList.remove("active");
      images[activeIndex].classList.add("previous");

      images[teamIndex].classList.add("active");
      images[teamIndex].classList.remove("previous");

      activeIndex = teamIndex;
    });
  });
});

$(document).ready(function () {
  // Tabs in new-arrival sections
  $('.new-arrival-sec').each(function () {
    const $tabSection = $(this);
    $tabSection.find('.tab').on('click', function (evt) {
      evt.preventDefault();
      $tabSection.find('.tab').removeClass('active');
      $tabSection.find('.tab-content').removeClass('active');
      $(this).addClass('active');
      const target = $(this).data('toggles-target');
      if (target) {
        $tabSection.find(target).addClass('active');
      }
    });
  });

  // Footer toggle accordion
  $('.custom-footer-middle h3').on('click', function () {
    $(this).next('.custom-footer-item ul, .addres-footer').toggle();
    $(this).toggleClass('active');
  });

  // Player select box interaction
  $('.select-player-select-box-item label').click(function () {
    const pselectVal = $(this).text();
    const playerName = $(this).data('playerName');
    const playerNumber = $(this).data('playerNumber');

    $(this).addClass('active').siblings().removeClass('active');
    $(this).closest('.select-player-select-box').find('h2').text(pselectVal);

    // Update hidden fields
    $('#CustomName').val(playerName).trigger('change');
    $('#CustomNumber').val(playerNumber).trigger('change');
    $('#CustomerName').val(playerName).trigger('change');
    $('#CustomerNumber').val(playerNumber).trigger('change');

    $(this).closest('.select-player-select-box-main').hide();
  });

  // Sync name input
  $('#CustomerName').on('input', function () {
    $('#CustomName').val($(this).val());
  });

  // Sync number input with validation
  $('#CustomerNumber').on('input', function () {
    let customerNumber = $(this).val();
    if (+customerNumber > 99) {
      customerNumber = customerNumber.slice(0, 2); // Limit to 2 digits
    }
    $('#CustomNumber').val(customerNumber);
  });

  // Toggle player select box
  $('.select-player-select-box h2').on('click', function () {
    $('.select-player-select-box-main').toggle();
  });

  // Toggle personalization/player selection
  $('.player').on('click', function () {
    $('.select-player-select-box').show();
    $('.select-personaliz').hide();
  });

  $('.personalise').on('click', function () {
    $('.select-player-select-box').hide();
    $('.select-personaliz').show();
  });

  // Reset both selection boxes and inputs
  $('.pdp-none').on('click', function (e) {
    e.preventDefault();
    $('.select-player-select-box, .select-personaliz').hide();
    $('#CustomName, #CustomNumber').val('');
  });

  // Customization list toggle
  $('.customize-check-box li').click(function () {
    $('.customize-check-box li').removeClass('active');
    $(this).addClass('active');
  });

  // Readmore toggle
  $('.readmore').click(function () {
    $('.product-detals').addClass('active');
    $(this).hide();
  });

  // Mega menu tab switch
  $(document).on('click', '.header-mega-menu-header .tab', function () {
    $('.header-mega-menu-header .tab').removeClass('active');
    $('.menu-drawer__navigation-container .tab-content').removeClass('active');
    $(this).addClass('active');
    const target = $(this).data('toggles-target');
    $(target).addClass('active');
  });
});



  $('.toggle-description-btn').on('click', function () {
      const $content = $(this).siblings('.accordion__content');
      $content.toggleClass('expanded');

      const isExpanded = $content.hasClass('expanded');
      $(this).text(isExpanded ? 'Read Less' : 'Read More');
    });



$('body').on('click', '.mobile-facets__summary', function () {
  $(this).toggleClass('active');
  $(this).next('.mobile-facets__list').toggleClass('active');
});

  $('.header__inline-menu  li.mege-menu').on('mouseenter', function() {
    $(this).closest('ul.list-menu--inline').addClass('active');
  });

  $('.header__inline-menu  li.mege-menu').on('mouseleave', function() {
    $(this).closest('ul.list-menu--inline').removeClass('active');
  });


document.addEventListener('DOMContentLoaded', function () {
  const descElement = document.getElementById('collection-description');
  const toggleButton = document.getElementById('toggle-description');

  if (!descElement || !toggleButton) return;

  const fullHTML = descElement.innerHTML.trim();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = fullHTML;
  const fullText = tempDiv.innerText || tempDiv.textContent;

  // Set character limit based on screen width
  const isMobile = window.innerWidth <= 768;
  const charLimit = isMobile ? 100 : 200;

  if (fullText.length > charLimit) {
    const shortHTML = safeTruncateHTML(fullHTML, charLimit) + '...';

    descElement.setAttribute('data-full-html', fullHTML);
    descElement.setAttribute('data-short-html', shortHTML);
    descElement.innerHTML = shortHTML;

    toggleButton.style.display = 'inline';
    toggleButton.innerText = 'READ MORE';

    let expanded = false;

    toggleButton.addEventListener('click', function () {
      if (expanded) {
        descElement.innerHTML = descElement.getAttribute('data-short-html');
        toggleButton.innerText = 'READ MORE';
      } else {
        descElement.innerHTML = descElement.getAttribute('data-full-html');
        toggleButton.innerText = 'READ LESS';
      }
      expanded = !expanded;
    });
  }

  // --- Helper Function ---
  function safeTruncateHTML(html, limit) {
    const div = document.createElement('div');
    div.innerHTML = html;
    let charCount = 0;
    const walker = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null, false);

    const nodesToRemove = [];

    while (walker.nextNode()) {
      const node = walker.currentNode;
      const textLength = node.textContent.length;

      if (charCount + textLength > limit) {
        const allowed = limit - charCount;
        node.textContent = node.textContent.slice(0, allowed);
        // Remove all nodes after this
        let next;
        while ((next = walker.nextNode())) {
          nodesToRemove.push(next);
        }
        break;
      }
      charCount += textLength;
    }

    // Remove all remaining nodes safely
    nodesToRemove.forEach(n => n.parentNode && n.parentNode.removeChild(n));

    return div.innerHTML;
  }
});


// Select the element to observe
const targetNode = document.querySelector('product-recommendations');
if(targetNode) {
// Options for the observer
const config = { attributes: true, attributeFilter: ['class'] };

// Callback function to execute when mutations are observed
const callback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      console.log('The class attribute was modified:', mutation.target.classList);

      const $slider = $('.related-product-slider');
      if(!$slider) return;
      const maxDots = 5;

      // Prevent re-initialization
      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      // Add slide counter if it doesn't exist
      if ($('#slick-slide-counter').length === 0) {
        $slider.after('<div id="slick-slide-counter" style="text-align:right; margin-top:10px; font-size:14px; color:#333;"></div>');
      }

      // Init Slick
      $slider
        .on('init reInit afterChange', function (event, slick, currentSlide) {
          const i = (typeof currentSlide === 'undefined' ? 0 : currentSlide) + 1;
          $('#slick-slide-counter').text(`${i} / ${slick.slideCount}`);
          updateDots(slick);
        })
        .slick({
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 4.2,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 4,
                infinite: false,
                dots: true
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.6,
                slidesToScroll: 1,
                dots: true
              }
            }
          ]
        });

      // Show only a limited number of dots
      function updateDots(slick) {
        if (!slick.$dots) return;

        const $dots = slick.$dots.find('li');
        const totalDots = $dots.length;
        const currentSlide = slick.currentSlide || 0;
        const currentDot = Math.floor(currentSlide / slick.options.slidesToScroll);

        let start = Math.max(0, currentDot - Math.floor(maxDots / 2));
        let end = Math.min(totalDots, start + maxDots);

        if (end - start < maxDots) {
          start = Math.max(0, end - maxDots);
        }

        $dots.hide();
        $dots.slice(start, end).show();
      }
    }
  }
};

// Create and start the observer
const observer = new MutationObserver(callback);
observer.observe(targetNode, config);
}